import findIndex from "lodash/fp/findIndex";
import findLast from "lodash/fp/findLast";
import findLastIndex from "lodash/fp/findLastIndex";
import isEqual from "lodash/fp/isEqual";
import isString from "lodash/fp/isString";
import first from "lodash/fp/first";
import last from "lodash/fp/last";
import each from "lodash/fp/each";
import moment from "moment";
import constants from "../../core/constants";
import isNil from "lodash/fp/isNil";

import skipStationDialogController from "./skipStationDialog/skipStationDialog.controller";
import skipStationDialogTemplate from "./skipStationDialog/skipStationDialog.html";

class Controller {
  constructor($injector, $mdDialog, $timeout, Mapie) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$timeout = $timeout;
    this.Mapie = Mapie;
    this.Events = $injector.get("Events");

    this.schedulesETA = [];
  }

  $onInit() {
    this.statusToggler();
    this.rideLocationEvent = this.Events.getRideLocationEvent(
      this.ride._id.value
    );
    this.Events.on(this.realtimeEvent, this.statusToggler.bind(this));
    this.Events.on(this.rideLocationEvent, this.updateBusLocation.bind(this));
    this.Events.on(
      this.connectionStatusEvent,
      this.connectionStatus.bind(this)
    );
  }

  updateBusLocation(data) {
    if (!data) return;
    if (isString(data)) data = JSON.parse(data);

    const lat = data.location ? data.location.lat : data.lat;
    const lng = data.location ? data.location.lng : data.lng;
    this.busLocation = { lat, lng };
  }

  mapSchedulesETA() {
    each((scheduleETA) => {
      const findById = (schedule) => scheduleETA._id === schedule.station._id;
      const scheduleIdx = findIndex(findById)(this.schedules);
      const { data, isLiveETA } = scheduleETA;

      if (scheduleIdx >= 0) {
        this.schedules[scheduleIdx].eta = { ...data, isLiveETA };
      }
    })(this.schedulesETA);
  }

  calculateETA(schedule, idx) {
    this.schedules[idx].isLoadingETA = true;
    const stationLocation = [
      last(schedule.station.loc.coordinates),
      first(schedule.station.loc.coordinates),
    ];
    const busLocation = [this.busLocation.lat, this.busLocation.lng];

    this.Mapie.calculateDistance(busLocation, stationLocation).then(
      (response) => {
        const durationDistance = this.Mapie.getDurationDistance(response);

        const findById = (eta) => eta._id === schedule.station._id;
        const etaIdx = findIndex(findById)(this.schedulesETA);

        if (etaIdx < 0) {
          this.schedulesETA.push({
            _id: schedule.station._id,
            isLiveETA: true,
            data: {
              duration: moment()
                .add(durationDistance.duration.value, "seconds")
                .format(constants.timeFormat),
              distance: durationDistance.distance.text,
            },
          });
        } else {
          this.schedulesETA[etaIdx] = {
            ...this.schedulesETA[etaIdx],
            data: {
              duration: moment()
                .add(durationDistance.duration.value, "seconds")
                .format(constants.timeFormat),
              distance: durationDistance.distance.text,
            },
          };
        }

        this.mapSchedulesETA();
        this.schedules[idx].isLoadingETA = false;
      },
      () => {
        this.schedules[idx].isLoadingETA = false;
      }
    );
  }

  hasActual(item) {
    return Boolean(!isNil(item.actual) && !item.isSkipped);
  }

  hasNotActual(item) {
    return Boolean(isNil(item.actual) && item.isUpcoming && !item.isSkipped);
  }

  lastArrived(item) {
    return Boolean(item.actual && !item.isSkipped);
  }

  getLastdestination() {
    return this.status.name === "completed"
      ? findLastIndex(this.lastArrived, this.schedules)
      : this.schedules.length - 1;
  }

  getShouldDepart() {
    return findLastIndex(this.hasActual, this.schedules);
  }

  getShouldArrive() {
    return findIndex(this.hasNotActual, this.schedules);
  }

  getRideTiming() {
    if (this.status.name !== "completed") return;
    const startTime = this.schedules[0].departure;
    const endTime = findLast(this.hasActual)(this.schedules);

    return { startTime, endTime: endTime.actual };
  }

  statusToggler(schedules = this.schedules) {
    this.schedules = schedules;
    const lastDestinationIdx = this.getLastdestination();
    const shouldDepartedIdx = this.getShouldDepart();
    const shouldArrivedIdx = this.getShouldArrive();
    let lastPastNonSkippedIdx = 0;
    this.mapSchedulesETA();
    const lastPastNonSkippedStation = this.schedules
      .filter(
        (station) =>
          !isNil(station.actual) && station.actual.toLowerCase() !== "skipped"
      )
      .slice(-1)[0];

    lastPastNonSkippedIdx = this.schedules.findIndex(
      (s) =>
        !isNil(lastPastNonSkippedStation) &&
        s.stationInstance.station._id ===
          lastPastNonSkippedStation.stationInstance.station._id
    );
    const remainingAfterLastSkipped =
      lastPastNonSkippedIdx >= 0
        ? this.schedules.slice(lastPastNonSkippedIdx + 1)
        : [];
    const shouldDepart =
      remainingAfterLastSkipped.filter(
        (s) => s.stationInstance.status === "skipped"
      ).length !== remainingAfterLastSkipped.length;

    this.rideDuration = this.getRideTiming();
    if (lastDestinationIdx >= 0) {
      this.schedules[lastDestinationIdx].isLast = true;
    }

    if (shouldArrivedIdx >= 0) {
      this.schedules[shouldArrivedIdx].shouldArrive = true;
    }
    if (
      shouldDepartedIdx >= 0 &&
      this.ride.coming_stations.length > 0 &&
      shouldDepart
    ) {
      const currentStation = this.schedules[shouldDepartedIdx].stationInstance;
      const isDepartedIdx = (currentStation.actions || []).findIndex(
        (item) => item.action === "depart"
      );
      const isAlreadyDeparted = isDepartedIdx >= 0;
      this.schedules[shouldDepartedIdx].shouldDepart = !isAlreadyDeparted;
    }
  }

  getConfirmDialog(title, confirmClick) {
    return this.$mdDialog
      .confirm()
      .title(title)
      .ok(confirmClick || "Ok")
      .cancel("Cancel");
  }

  _getHandleBookingsDialog(station) {
    return this.$mdDialog.show({
      controller: skipStationDialogController,
      controllerAs: "$ctrl",
      template: skipStationDialogTemplate,
      clickOutsideToClose: true,
      locals: { station, ride: this.ride },
    });
  }

  arrivedStation(station) {
    const arriveStationConfirm = this.getConfirmDialog(
      `Are you sure you want to mark '${station.name}' 'arrived'?`
    );

    this.$mdDialog.show(arriveStationConfirm).then(() => {
      this.Events.emit(this.arrivedEvent, station);
    });
  }

  departedStation(station) {
    const departedStationConfirm = this.getConfirmDialog(
      `Are you sure you want to mark '${station.name}' 'departed'?`
    );
    const handleDepartureConfirmation = () => {
      const handleBookingsDialog = this._getHandleBookingsDialog(station);

      handleBookingsDialog.then(() => {
        this.Events.emit(this.departedEvent, station);
      });
    };

    this.$mdDialog
      .show(departedStationConfirm)
      .then(handleDepartureConfirmation);
  }

  connectionStatus(status) {
    if (!status || isEqual(status, this.connection)) return;

    this.connection = status;
  }

  skipStation(station) {
    const skipStationConfirm = this.getConfirmDialog(
      `Are you sure you want to mark '${station.name}' 'skipped'?`
    );

    const handleSkipConfirmation = () => {
      const handleBookingsDialog = this._getHandleBookingsDialog(station);

      handleBookingsDialog.then(() => {
        this.Events.emit(this.skipStationEvent, station.name);
      });
    };

    this.$mdDialog.show(skipStationConfirm).then(handleSkipConfirmation);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/stationsTimeline/stationsTimeline.controller.js